import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Restaurant, TieredRestaurant } from '@shared-data';

@Component({
  selector: 'app-unassign-restaurant',
  templateUrl: './unassign-restaurant.component.html',
  styleUrl: './unassign-restaurant.component.scss',
})
export class UnassignRestaurantComponent {
  @Input()
  restaurant!: TieredRestaurant;

  @Output()
  onConfirm: EventEmitter<Restaurant | null> =
    new EventEmitter<Restaurant | null>();

  onCancel() {
    this.onConfirm.emit(null);
  }

  onAccept() {
    this.onConfirm.emit(new Restaurant(this.restaurant));
  }
}
